const BackSVG = require('!raw-loader!../assets/icons/back.svg');

export default {
    methods: {
        handlePaste(event) {
            event.preventDefault();
            const text = (event.clipboardData || window.clipboardData).getData('text/plain');

            const selection = window.getSelection();
            if (!selection.rangeCount) return;

            const range = selection.getRangeAt(0);
            range.deleteContents();
            range.insertNode(document.createTextNode(text));

            range.setStartAfter(range.endContainer);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        },

        handleEnter(event) {
            event.target.blur();
        },

        handleEditableMouseDown(event) {
            const clickedElement = event.currentTarget;
            const activeElement = document.activeElement;

            if (activeElement &&
                activeElement !== clickedElement &&
                activeElement.isContentEditable &&
                activeElement.getAttribute('contenteditable') === 'true') {
                activeElement.blur();
            }
        },

        getEffectiveStyle() {
            if (this.effective) return this.effective;
            if (this.effectiveStyle) return this.effectiveStyle;
            if (this.effectiveStyleData) return this.effectiveStyleData;
            return {};
        },

        rgba(c, applyOverallOpacity = true) {
            if (!c || typeof c !== 'object') return 'rgba(255,255,255,1)';

            const effective = this.getEffectiveStyle();
            const x = c.__ob__ ? c : c;
            const finalAlpha = applyOverallOpacity ? (effective.opacity ?? 1) : (x.a ?? 1);
            return `rgba(${x.r ?? 255}, ${x.g ?? 255}, ${x.b ?? 255}, ${finalAlpha})`;
        },

        updateTextField(fieldName, event) {
            const element = event.target;
            const rawText = element.textContent || '';
            const cleanedText = rawText.replace(/\u200B/g, '');
            const newText = cleanedText.trim();

            if (!newText || newText.length === 0) {
                const fallbackValue = '\u200B';
                element.textContent = fallbackValue;
                const updatedData = JSON.parse(JSON.stringify({
                    ...this.menuData,
                    [fieldName]: fallbackValue
                }));
                this.$emit('update:menu-data', updatedData);
                return;
            }

            const currentValue = this.menuData[fieldName];
            const cleanedCurrent = currentValue ? String(currentValue).replace(/\u200B/g, '').trim() : '';
            
            if (newText !== cleanedCurrent) {
                const updatedData = JSON.parse(JSON.stringify({
                    ...this.menuData,
                    [fieldName]: newText
                }));
                this.$emit('update:menu-data', updatedData);
            }
        },
        
        handleTextFieldInput(fieldName, event) {
            const element = event.target;
            const rawText = element.textContent || '';
            const cleanedText = rawText.replace(/\u200B/g, '');
            
            if (!cleanedText || cleanedText.trim().length === 0) {
                const fallbackValue = '\u200B';
                element.textContent = fallbackValue;
                const range = document.createRange();
                const selection = window.getSelection();
                range.selectNodeContents(element);
                range.collapse(false);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },

        updateButtonText(index, event, buttonArrayName = 'buttons') {
            const element = event.target.querySelector('.btn-text') || event.target;
            const rawText = element.textContent || '';
            const newText = rawText.replace(/\u200B/g, '').trim();

            const buttons = [...this.menuData[buttonArrayName] || []];
            if (!buttons[index]) buttons[index] = {};

            const menuData = {
                ...this.menuData,
                [buttonArrayName]: buttons.map((btn, i) => {
                    if (i === index) {
                        return { ...btn, text: newText || '\u200B' };
                    }
                    return btn;
                })
            };
            this.$emit('update:menu-data', menuData);
        },

        isEmptyText(value) {
            return !value || (typeof value === 'string' && value.trim().length === 0);
        },

        isButtonHidden(btn) {
            if (btn.enabled === false) {
                return true;
            }

            if (this.isStylePreview || this.isPreview) {
                return false;
            }

            if (this.enableInlineEdit) {
                return false;
            }

            return this.isEmptyText(btn.text);
        },

        getIconStylesFromSvg(svgModule, options = {}) {
            const effective = this.getEffectiveStyle();
            const textColor = effective.textColor || {r: 255, g: 255, b: 255, a: 1};
            const textColorRgba = this.rgba(textColor, false);

            const svgContent = svgModule.default || svgModule;
            const encodedSvg = encodeURIComponent(svgContent);
            const dataUri = `url("data:image/svg+xml,${encodedSvg}")`;

            return {
                width: '100%',
                height: options.height || '100%',
                ...(options.marginTop && { marginTop: options.marginTop }),
                ...(options.marginBottom && { marginBottom: options.marginBottom }),
                backgroundColor: textColorRgba,
                WebkitMaskImage: dataUri,
                maskImage: dataUri,
                WebkitMaskSize: 'contain',
                maskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskPosition: 'center'
            };
        },

        getNavIconStyles(direction) {
            const svgModule = BackSVG;
            const baseStyles = this.getIconStylesFromSvg(svgModule, {
                height: '70%',
                marginTop: 'auto',
                marginBottom: 'auto'
            });
            if (direction === 'next') {
                return {
                    ...baseStyles,
                    transform: 'rotate(180deg)'
                };
            }
            return baseStyles;
        }
    }
};

